import { render, staticRenderFns } from "./MolecularFormulaManualCard.vue?vue&type=template&id=149f75e4&scoped=true"
import script from "./MolecularFormulaManualCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./MolecularFormulaManualCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MolecularFormulaManualCard.vue?vue&type=style&index=0&id=149f75e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149f75e4",
  null
  
)

export default component.exports